/*
 * @Author: Dzy
 * @Date: 2022-08-10 11:01:01
 * @LastEditors: Dzy
 * @LastEditTime: 2022-08-10 11:05:34
 * @Description: 编辑字段临时存储
 */
import { defineStore } from 'pinia'

export const useTempStore = defineStore('tempBusi', {
  state: () => {
    return {
      tempData: null
    }
  },

  actions: {
    update_tempData(data) {
      this.tempData = data
    }
  },
  // 所有数据持久化 插件其他配置
  persist: {
    // 修改为 sessionStorage，默认为 localStorage
    storage: window.sessionStorage
  }
})
